export default {
  LIST(state, data) {
    state.examCheckList = data
  },
  GET(state, data) {
    state.examCheck = { ...data }
  },
}
